import { render } from "./OffersMenu.vue?vue&type=template&id=21f049a4&scoped=true"
import script from "./OffersMenu.vue?vue&type=script&lang=js"
export * from "./OffersMenu.vue?vue&type=script&lang=js"

import "./OffersMenu.vue?vue&type=style&index=0&id=21f049a4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f049a4"]])

export default __exports__